import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { LandlordDashboard, LandlordRentPayment } from 'ux/Landlord/types';

type LandlordState = {
  dashboard: LandlordDashboard | null;
  rentPayments: LandlordRentPayment[] | null;
};

export const LANDLORD_INITIAL_STATE: LandlordState = {
  dashboard: null,
  rentPayments: null
};

const landlordSlice = createSlice({
  name: 'Landlord',
  initialState: LANDLORD_INITIAL_STATE,
  reducers: {
    setLandlordDashboard: (state, action: PayloadAction<LandlordDashboard>) => {
      state.dashboard = action.payload;
    },
    setLandlordRentPayments: (state, action: PayloadAction<LandlordRentPayment[]>) => {
      state.rentPayments = action.payload;
    }
  }
});

export const { actions } = landlordSlice;

export default landlordSlice.reducer;
